var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('client-only',[_c('span',[(_vm.additionalLogo)?_c('img',{staticClass:"header__logo--additional",attrs:{"src":_vm.additionalLogo,"width":"22","height":"26","alt":""}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }